var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('button',{on:{"click":function($event){return _vm.$emit('click:back')}}},[_c('img',{attrs:{"src":require("@/assets/images/main/svg/button__Previous.svg")}})]),_c('div',{staticClass:"headtit"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }